import { TextInlineEditor } from 'components/inline_edit/TextInlineEditor';
import { NoValue } from 'components/no_value/NoValue';
import { CorporationsTableCellProps } from 'pages/Settings/Corporations/CorporationsTable';
import { updateCorporation } from 'utils/corporation';

export function CorporationAbbreviationCell({
    rowData,
    onChange,
}: CorporationsTableCellProps) {
    const onUpdateCorporationAbbreviation = async (
        updatedAbbreviation: string | undefined
    ) => {
        if (!updatedAbbreviation) {
            throw new Error('Attempted to save corporation without an abbreviation');
        }
        try {
            onChange(
                await updateCorporation(rowData, {
                    Abbreviation: updatedAbbreviation,
                })
            );
        } catch {
            return 'Unable to save abbreviation for corporation';
        }
        return undefined;
    };

    return (
        <TextInlineEditor
            value={rowData.Abbreviation}
            renderValue={(value) => (!value ? <NoValue /> : value)}
            onConfirm={onUpdateCorporationAbbreviation}
            validate={(val) => {
                if (!val?.trim()) {
                    return 'Abbreviation is required';
                }
                if (val.length > 5) {
                    return 'Abbreviation must be 5 characters or less';
                }
                return undefined;
            }}
        />
    );
}
